/** ModalDialogのReact Portal挿入先DOM要素のID */
export const CREATE_PORTAL_ID = 'modal-dialog-create-portal-id';
